import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const InsightEdgeProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Aptitude Test Nigeria | Cognitive Assessment Lagos | InsightEdge"
        description="InsightEdge™ cognitive and reasoning assessment for Nigerian recruitment. Measure problem-solving, judgement, and decision-making ability. Fair, validated aptitude testing for graduate and professional recruitment in Nigeria."
        keywords="aptitude test Nigeria, cognitive assessment Lagos, reasoning test Nigeria, problem solving assessment Lagos, graduate aptitude test Nigeria, recruitment testing Africa"
        canonical="https://impactasportal.com/product/insightedge"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/insightedge?embed=true"
            title="InsightEdge™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default InsightEdgeProductPage;
